if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      /** @type {HTMLInputElement | null} */
      input = null;
      /** @type {HTMLInputElement | null} */
      currentVariant = null;
      /** @type {HTMLElement | null} */
      variantSelects = null;
      /** @type {HTMLButtonElement | null} */
      submitButton = null;
      /** @type {HTMLElement | null} */
      quantityForm = null;
      /** @type {(() => void) | undefined} */
      cartUpdateUnsubscriber = undefined;
      /** @type {(() => void) | undefined} */
      variantChangeUnsubscriber = undefined;

      constructor() {
        super();
        this.input = /** @type {HTMLInputElement | null} */ (this.querySelector('.quantity__input'));
        this.currentVariant = /** @type {HTMLInputElement | null} */ (this.querySelector('.product-variant-id'));
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = /** @type {HTMLButtonElement | null} */ (this.querySelector('[type="submit"]'));
      }

      connectedCallback() {
        if (!this.input) {return;}
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) {return;}
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (/** @type {{ data: { sectionId: string, html: Document } }} */ event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) {return;}
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        if (!this.input) {return;}
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) {min = Math.min(min, max);}
        if (data.cartQuantity >= data.min) {min = Math.min(min, data.step);}

        this.input.min = String(min);
        this.input.max = max !== null ? String(max) : '';
        this.input.value = String(min);
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) {return;}
        const loadingOverlay = /** @type {HTMLElement | null} */ (this.querySelector('.quantity__rules-cart .loading-overlay'));
        if (loadingOverlay) {loadingOverlay.classList.remove('hidden');}
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((/** @type {Error} */ e) => {
            console.error(e);
          })
          .finally(() => {
            const overlay = /** @type {HTMLElement | null} */ (this.querySelector('.quantity__rules-cart .loading-overlay'));
            if (overlay) {overlay.classList.add('hidden');}
          });
      }

      /**
       * @param {string | undefined} sectionId
       * @param {Document} html
       */
      updateQuantityRules(sectionId, html) {
        if (!this.quantityForm) {return;}
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        if (!quantityFormUpdated) {return;}
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (const selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) {continue;}
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (const attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {current.setAttribute(attribute, valueUpdated);}
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
